// src/hooks/useEscapeKey.js

import { useEffect } from "react";

/**
 * Calls `onEscape` when Escape is pressed, and optionally locks page scroll
 * while active.
 *
 * Lightbox and BidModal each had their own copy of this logic. Two copies
 * means they drift — BidModal's version, for instance, never restored the
 * previous overflow value correctly on unmount.
 *
 * @param {Function} onEscape   handler to run on Escape
 * @param {boolean}  active     whether the listener is attached
 * @param {boolean}  lockScroll freeze <body> scroll while active
 */
export default function useEscapeKey(onEscape, active = true, lockScroll = true) {
  useEffect(() => {
    if (!active) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onEscape();
    };
    window.addEventListener("keydown", onKeyDown);

    let prevOverflow;
    if (lockScroll) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      if (lockScroll) document.body.style.overflow = prevOverflow ?? "";
    };
  }, [onEscape, active, lockScroll]);
}
